// MODIFIED: Updated imports and hook usage for v2
import { useState } from "react";
import {
  CreateTableNew as CreateTable,
  SearchBar,
  GeneralMessage,
  useGeneralMessage,
} from "../../../../common/APICommon";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { useFinancialApprover } from "../../../hooks/useFinancialApprover";
import { FinancialApproverModal } from "./components/FinancialApproverModal";
import { LoadingSpinner } from "../../../../common/Loading";

function FinancialApprover({ user, userAccess }) {
  const { loading, data, handleFilter, saveApproverHierarchy } = useFinancialApprover();
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [mode, setMode] = useState("edit");
  const [currentPage, setCurrentPage] = useState(1);

  const openModal = (item, selectedMode = "edit") => {
    setSelectedData(item);
    setMode(selectedMode);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedData(null);
  };

  const handleSave = async (payload) => {
    const result = await saveApproverHierarchy(payload);
    if (result.success) {
      showGeneralMessage("Approver hierarchy saved successfully!", true);
    } else {
      showGeneralMessage("Failed to save. Check console for details.", false);
    }
    return result;
  };

  const headers = ["ID", "Employee ID", "Employee", "Hierarchy Count", "Actions"];
  const accessors = ["id", "employeeId", "fullName", "approverHierarchyCount", "actions"];

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: (item) => openModal(item, "edit"),
      visible: true,
    },
    {
      name: "View",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600",
      function: (item) => openModal(item, "view"),
      visible: true,
    },
  ];

  return (
    <>
      <div className="v2-module-container">
        <SearchBar handleFilter={handleFilter} />
        <CreateTable
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <FinancialApproverModal
        isOpen={showModal}
        onClose={closeModal}
        mode={mode}
        selectedData={selectedData}
        onSave={handleSave}
        loading={loading}
        showGeneralMessage={showGeneralMessage}
      />
			<LoadingSpinner loading={loading}/>
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </>
  );
}

export default FinancialApprover;